var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jc-component__range"},[_c('div',{staticClass:"jc-range",class:_vm.rangeStatus?'success':''},[_c('i',{class:_vm.rangeStatus?_vm.successIcon:_vm.startIcon,on:{"mousedown":_vm.rangeMove}}),_vm._v(" "+_vm._s(_vm.rangeStatus?_vm.successText:_vm.startText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }